<template>

    <div class="publication__section content-width">

        <div class="publication__section-row d-flex">

            <div class="publication__section-inner d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">Питомец</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in categories">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.pet_category_id.$model" :value="item.id">
                                <span class="circle"></span>
                                {{item.name}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.pet_category_id.$error">Выберете категорию.</div>

                </div>
            </div>


        </div>


    </div>

</template>

<script>

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PersonalCategories",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        categories() { return this.server.dictionaries.pet_category_id },

        pet_category_id: {
            get() { return this.GET_BY_KEY('pet_category_id') },
            set( val ) {

                if( +val === 3 || +val === 4 ) this.SET_PET_BY_KEY({ key: 'size', data: 'PET_SIZE_BELOW_TO_KNEE' })

                this.SET_PET_BY_KEY({ key: 'pet_category_id', data: val })
            }
        }
    },

    methods: {

        isValid() {
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: { pet_category_id: { required } }

}
</script>

<style scoped>

</style>
